module.exports = __webpack_public_path__ + "img/operate3.cf1349ba.png";